export default {
  badge: 'شارة',
  open: 'Open',
  close: 'إغلاق',
  dismiss: 'Dismiss',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Cancel',
  },
  dataIterator: {
    noResultsText: 'لم يتم إيجاد نتائج',
    loadingText: 'يتم جلب العناصر...',
  },
  dataTable: {
    itemsPerPageText: 'عدد الصفوف لكل صفحة:',
    ariaLabel: {
      sortDescending: 'مرتب تنازلياً.',
      sortAscending: 'مرتب تصاعدياً.',
      sortNone: 'غير مرتب.',
      activateNone: 'نشط لإزالة الترتيب.',
      activateDescending: 'نشط للترتيب تنازلياً.',
      activateAscending: 'نشط للترتيب تصاعدياً.',
    },
    sortBy: 'رتب حسب',
  },
  dataFooter: {
    itemsPerPageText: 'عدد العناصر لكل صفحة:',
    itemsPerPageAll: 'الكل',
    nextPage: 'الصفحة التالية',
    prevPage: 'الصفحة السابقة',
    firstPage: 'الصفحة الأولى',
    lastPage: 'الصفحة الأخيرة',
    pageText: '{0}-{1} من {2}',
  },
  dateRangeInput: {
    divider: 'to',
  },
  datePicker: {
    itemsSelected: '{0} محدد',
    range: {
      title: 'اختر التواريخ',
      header: 'أدخل التواريخ',
    },
    title: 'اختر التاريخ',
    header: 'أدخل التاريخ',
    input: {
      placeholder: 'أدخل التاريخ',
    },
    ariaLabel: {
      previousMonth: 'الشهر السابق',
      nextMonth: 'الشهر التالي',
      selectYear: 'اختر السنة',
      selectDate: '{0}',
      currentDate: 'اليوم، {0}',
    },
  },
  noDataText: 'لا توجد بيانات',
  carousel: {
    prev: 'المعروض السابق',
    next: 'المعروض التالي',
    ariaLabel: {
      delimiter: 'المعروض رقم {0} من {1}',
    },
  },
  calendar: {
    moreEvents: '{0} أكثر',
    today: 'Today',
  },
  input: {
    clear: 'Clear {0}',
    prependAction: '{0} prepended action',
    appendAction: '{0} appended action',
    otp: 'Please enter OTP character {0}',
  },
  fileInput: {
    counter: '{0} ملفات',
    counterSize: '{0} ملفات ({1} في المجموع)',
  },
  fileUpload: {
    title: 'Drag and drop files here',
    divider: 'or',
    browse: 'Browse Files',
  },
  timePicker: {
    am: 'صباحاً',
    pm: 'مساءً',
    title: 'Select Time',
  },
  pagination: {
    ariaLabel: {
      root: 'الإنتقال بين الصفحات',
      next: 'الصفحة التالية',
      previous: 'الصفحة السابقة',
      page: '{0} انتقل إلى الصفحة',
      currentPage: '{0} الصفحة الحالية رقمها',
      first: 'First page',
      last: 'Last page',
    },
  },
  stepper: {
    next: 'Next',
    prev: 'Previous',
  },
  rating: {
    ariaLabel: {
      item: 'القييم {0} من {1}',
    },
  },
  loading: 'Loading...',
  infiniteScroll: {
    loadMore: 'Load more',
    empty: 'No more',
  },
  rules: {
    required: 'هذه الخانة مطلوبه',
    email: 'يرجى إدخال بريد إلكتروني صالح',
    number: 'هذه الخانة يمكن أن تحتوي على أرقام فقط',
    integer: 'هذه الخانة يمكن أن تحتوي على أعداد صحيحة فقط',
    capital: 'هذه الخانة يمكن أن تحتوي على أحرف كبيرة فقط',
    maxLength: 'يجب أن تدخل بحد أقصى {0} حرف',
    minLength: 'يجب أن تدخل بحد أدنى {0} حرف',
    strictLength: 'طول الحقل المدخل غير صالح',
    exclude: 'الحرف {0} غير مسموح به',
    notEmpty: 'يرجى اختيار قيمة واحدة على الأقل',
    pattern: 'تنسيق غير صالح',
  },
  hotkey: {
    then: 'ثم',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'السهم العلوي',
    downArrow: 'السهم السفلي',
    leftArrow: 'السهم الأيسر',
    rightArrow: 'السهم الأيمن',
    backspace: 'مسافة للخلف',
    space: 'مسافة',
    plus: 'زائد',
    shortcut: 'اختصار لوحة المفاتيح: {0}',
  },
  video: {
    play: 'تشغيل',
    pause: 'إيقاف مؤقت',
    seek: 'بحث',
    volume: 'مستوى الصوت',
    showVolume: 'إظهار التحكم في مستوى الصوت',
    mute: 'كتم الصوت',
    unmute: 'إلغاء كتم الصوت',
    enterFullscreen: 'ملء الشاشة',
    exitFullscreen: 'الخروج من وضع ملء الشاشة',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'اختيار لون من الشاشة',
      hueSlider: 'درجة اللون',
      alphaSlider: 'الشفافية',
      redInput: 'أحمر',
      greenInput: 'أخضر',
      blueInput: 'أزرق',
      alphaInput: 'الشفافية',
      hueInput: 'درجة اللون',
      saturationInput: 'التشبع اللوني',
      lightnessInput: 'السطوع',
      hexInput: 'قيمة HEX',
      hexaInput: 'قيمة HEX مع الشفافية',
      changeFormat: 'تغيير تنسيق اللون',
    },
  },
}
